import {ApolloClient, InMemoryCache, createHttpLink} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';

import {getMandarkURL} from '@albert-io/environment';
import {getAuthenticationCookie} from '@albert-io/mandark/authentication';

import {BUILD_HEADER} from 'resources/mandark.resource';

const httpLink = createHttpLink({
  uri: `${getMandarkURL()}/graphql/query`,
  // https://www.apollographql.com/docs/react/networking/authentication#cookie
  credentials: 'include'
});

// TODO: remove this when we remove SSR
const getAuthCookie = (context) => {
  if (typeof window === 'undefined') {
    return context?.req?.cookies ? getAuthenticationCookie(context.req.cookies) : null;
  }
  return null;
};

const authLink = setContext((_, {headers, context}) => {
  const authCookie = getAuthCookie(context);

  return {
    headers: {
      ...headers,
      ...BUILD_HEADER(),
      ...(authCookie ? {Cookie: `guardian_authorization_0_token=${authCookie}`} : {})
    }
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  connectToDevTools: process.env.NODE_ENV === 'development'
});

export default client;
